export default function Marquee({ items = [], dark = false }) {
  if (!items.length) return null;
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      className={`marquee border-y py-5 ${dark ? "border-ink/10 bg-paper text-ink/45" : "border-paper/10 bg-ink text-paper/40"}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <span key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl tracking-[0.22em] uppercase px-8">{item}</span>
                <span className="text-crimson text-xs">✦</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
